import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";

import "./App.css";
import Loading from "./pages/Loading/Loading";

const Home = lazy(() => import("./pages/Home/Home"));
const OurProject = lazy(() => import("./pages/OurProject/OurProject"));
const MeetTheTeam = lazy(() => import("./pages/MeetTheTeam/MeetTheTeam"));
const ProjectTimeline = lazy(() =>
  import("./pages/ProjectTimeline/ProjectTimeline"),
);
const Gallery = lazy(() => import("./pages/Gallery/Gallery"));
const FinalReport = lazy(() => import("./pages/FinalReport/FinalReport"))

function App() {
  return (
    <Router>
      <Suspense fallback={<Loading />}>
        <Navbar />
        <Switch>
          <Route path="/projectoutcomes">
            <FinalReport />
          </Route>
          <Route path="/gallery">
            <Gallery />
          </Route>
          <Route path="/project-timeline/:year?/:month?">
            <ProjectTimeline />
          </Route>
          <Route path="/meet-the-team">
            <MeetTheTeam />
          </Route>
          <Route path="/our-project">
            <OurProject />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
        <Footer />
      </Suspense>
    </Router>
  );
}

export default App;
